import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import $ from 'jquery';

function IndoNepalMoneyTransfer1() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [data, setData] = useState(false);
  const [base64, setBase64] = useState(false);
  const [commissionData, setCommissionData] = useState(false);
  const [kycData, setKYCData] = useState(false);
  const [senderData, setSenderData] = useState(false);
  const [receiverData, setReceiverData] = useState(false);
  const [processId, setProcessId] = useState('');
  const [transferData, setTransferData] = useState(false);
  const [partnerUniqueRefNo, setPartnerUniqueRefNo] = useState(false);
  const [tokenData, setTokenData] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [addReceiverModal, setAddReceiverModal] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [paymentMode, setPaymentMode] = useState(false);
  const [bankName, setBankName] = useState(false);
  const [bankBranchName, setBankBranchName] = useState(false);
  const [states, setStates] = useState(false);
  const [districts, setDistricts] = useState(false);
  const [localLevel, setLocalLevel] = useState(false);
  const [idType, setIdType] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setViewData(false);
    setAddReceiverModal(false);
    setErrors(false);
    setProcessId("");
  }
  const handleShow = () => setShowModal(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    jsonData['nationality'] = "NPL";
    jsonData['id_proof_front'] = base64 && base64.id_proof_front && base64['id_proof_front'];
    jsonData['id_proof_back'] = base64 && base64.id_proof_back && base64['id_proof_back'];
    jsonData['photo'] = base64 && base64.photo && base64['photo'];
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        if (!jsonData?.otp) {
          setSenderData(jsonData);
          const response = await axios.post('/prabhuRemittance/sendOTP', {
            action: "CreateCustomer",
            mobile: jsonData?.mobile,
            fullName: jsonData?.fullName,
            //firstName: jsonData?.firstName,
            //middleName: jsonData?.middleName,
            //lastName: jsonData?.lastName,
            id_type: jsonData?.id_type
          });
          const { status, process_id, message } = response.data;
          if (status) {
            setProcessId(process_id);
          }
          toast(message);
        }
        else {
          let data = { ...senderData, otp: jsonData?.otp, process_id: processId };
          const response = await axios.post('/prabhuRemittance/createCustomer', data);
          const { status, message } = response.data;
          if (status) {
            setShowModal(false);
          } else {
            setProcessId("");
          }
          toast(message);
        }
      } catch (error) {
        setProcessId("");
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const addReceiverSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    } else {
      try {
        jsonData["customerId"] = data[0].customerId;
        setReceiverData(jsonData);
        const response = await axios.post('/prabhuRemittance/createReceiver', jsonData);
        const { status, message } = response.data;
        if (status) {
          setAddReceiverModal(false);
        }
        toast(message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const handleViewData = (index) => {
    setViewIndex(index);
    setViewData(true);
  };

  const verifyKyc = async () => {
    try {
      const response = await axios.post('/v2/remittance/customer/ekycinitiate', { CustomerId: kycData?.customerId });
      const { StatusCode, ResponseMessage, Url, PartnerUniqueRefNo, tokenData } = response.data;
      if (StatusCode == "0") {
        toast(ResponseMessage);
      }
      else {
        setPartnerUniqueRefNo(PartnerUniqueRefNo);
        setTokenData(tokenData);
        window.open(Url, '_blank');
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const transferAmountSubmit = async (e) => {
    e.preventDefault();
    try {
      const { transferAmount, otp } = e.target;
      if (!otp) {
        let sendData = {
          action: "SendTransaction",
          amount: transferAmount.value,
          customer_id: data[0].customerId,
          payment_mode: data[0].receivers[viewIndex].paymentMode,
          receiver_id: data[0].receivers[viewIndex].receiverId,
          sender_mobile: data[0].mobile
        }
        const response = await axios.post('/prabhuRemittance/sendOTP', sendData);
        const { status, process_id, message } = response.data;
        if (status) {
          setProcessId(process_id);
          setTransferData({ transferAmount: parseInt(transferAmount.value) });
        }
        toast(message);
      }
      else {
        //let data = { ...senderData, otp: otp.value, process_id: processId };
        let transferAmountData = {
          account_number: data[0].receivers[viewIndex].acNumber,
          account_type: null,
          bank_branch_id: data[0].receivers[viewIndex].BankBranchId,
          bank_name: data[0].receivers[viewIndex].BankName,
          branch_name: data[0].receivers[viewIndex].BankBranchName,
          collected_amount: (parseInt(commissionData?.serviceCharge) + transferData?.transferAmount),
          customer_id: data[0]?.customerId,
          exchange_rate: 1.6,
          income_source: data[0]?.income_source,
          otp: otp.value,
          pay_amount: (1.6 * transferData?.transferAmount),
          pay_currency: "NPR",
          payment_mode: data[0].receivers[viewIndex].paymentMode,
          payout_country: "Nepal",
          process_id: processId,
          receiver_address: data[0].receivers[viewIndex].Address,
          receiver_city: null,
          receiver_gender: data[0].receivers[viewIndex].Gender,
          receiver_id: data[0].receivers[viewIndex].receiverId,
          //receiver_mobile: data[0].receivers[viewIndex].Mobile,
          receiver_name: data[0].receivers[viewIndex].name,
          relectionship: data[0].receivers[viewIndex].Relationship,
          //remittance_reason: transferData?.remittanceReason,
          //source_of_fund: transferData?.sourceOfFund,
          send_amount: transferData?.transferAmount,
          send_currency: "INR",
          sender_address: data[0]?.address,
          sender_city: data[0]?.city,
          sender_district: data[0]?.district,
          sender_dob: data[0]?.date_of_birth,
          sender_employer: data[0]?.employer,
          sender_gender: data[0]?.gender,
          sender_id: data[0]?._id,
          sender_id_expiry_date: null,
          sender_id_issue_place: null,
          sender_id_number: data[0]?.id_number,
          sender_id_type: data[0]?.id_type,
          sender_mobile: data[0]?.mobile,
          sender_name: data[0]?.name,
          sender_nationality: data[0]?.nationality,
          sender_phone: null,
          sender_state: data[0]?.state,
          service_charge: commissionData?.serviceCharge
        };
        const response = await axios.post('/prabhuRemittance/sendTransaction', transferAmountData);
        const { status, message } = response.data;
        if (status) {
          //setShowModal(false);
          handleClose();
        }
        else {
          //setShowModal(false);
        }
        toast(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { search_by, id_number, mobile } = e.target;
    const isValid = /^\d{10}$/.test(mobile.value);
    if (!isValid) {
      setErrors({ mobile: "Mobile should be 10 number" });
    }
    else {
      setErrors(false);
      let data = {};
      let url = "";
      if (search_by.value == "id") {
        data = {
          type: "id_number",
          mobile: id_number.value
        };
        url = '/v2/remittance/search/customer/id_number';
      }
      else {
        data = {
          type: "mobile",
          mobile: mobile.value
        };
        url = '/prabhuRemittance/getCustomerByMobile';
      }
      try {
        const response = await axios.post(url, data);
        const { status, message, customer, result } = response.data;
        if (status) {
          setData(result);
        } else {
          if (message == "kyc_not_verified") {
            setKYCData(customer);
            setData([customer]);
            setPartnerUniqueRefNo(false);
            setTokenData(false);
          }
          toast(message);
          //setData(false);
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const getStateData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/prabhuRemittance/getStates', { country: e.target.value });
      const { status, country } = response.data;
      if (status) {
        setStates({ ...states, [country]: response.data.data });
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getDistrictData = async (e, country1) => {
    deleteError(e);
    try {
      const response = await axios.post('/prabhuRemittance/getDistrict', { country: country1, state: e.target.value });
      const { status, country } = response.data;
      if (status) {
        setDistricts({ ...districts, [country]: response.data.data });
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getLocalLevelData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/prabhuRemittance/getLocalLevel', { district: e.target.value });
      const { status } = response.data;
      if (status) {
        setLocalLevel(response.data.data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    if (currentUser && currentUser.prabhuMoneyTransfer == false) {
      navigate('/admin/dashboard');
    }
  }, [currentUser]);

  const captureFinger = async (e) => {
    e.preventDefault();
    const { CustomerType, SourceIncomeType, AnnualIncome } = e.target;
    const finalUrl = "https://127.0.0.1:11100/rd/capture";
    const XML = `<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="2" format="0"   pidVer="2.0" timeout="10000" pTimeout="20000" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>`;
    //const XML = `<?xml version="1.0"?><PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" iType="0" pCount="0" pType="0" format="0" pidVer="2.0" timeout="10000" otp="" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="" env="PP" /><CustOpts><Param name="" value="" /></CustOpts></PidOptions>`;
    try {
      $.ajax({
        type: "CAPTURE",
        async: false,
        crossDomain: true,
        url: finalUrl,
        data: XML,
        contentType: "text/xml; charset=utf-8",
        processData: false,
        success: async function (resData) {
          var $doc = $.parseXML(resData);
          var pid = $($doc).find("Data").text();
          var errcode = $($doc).find("Resp").attr("errCode");
          var errinfo = $($doc).find("Resp").attr("errInfo");
          var skey = $($doc).find("Skey").text();
          var ci = parseInt($($doc).find("Skey").attr("ci"));
          var hmac = $($doc).find("Hmac").text();
          var type = $($doc).find("Data").attr("type");
          var dpId = $($doc).find("DeviceInfo").attr("dpId");
          var rdsId = $($doc).find("DeviceInfo").attr("rdsId");
          var rdsVer = $($doc).find("DeviceInfo").attr("rdsVer");
          var dc = $($doc).find("DeviceInfo").attr("dc");
          var mi = $($doc).find("DeviceInfo").attr("mi");
          var mc = $($doc).find("DeviceInfo").attr("mc");
          let data = {
            pid, errcode, errinfo, skey, ci, hmac, type, dpId, rdsId, rdsVer, dc, mi, mc
          };
          try {
            let response = await axios.post('/v2/remittance/customer/ekycenrollment', { ...data, CustomerId: parseInt(kycData?.customerId), PartnerUniqueRefNo: partnerUniqueRefNo, tokenData, CustomerType: CustomerType.value, SourceIncomeType: SourceIncomeType.value, AnnualIncome: AnnualIncome.value });
            const { StatusCode, ResponseMessage } = response.data;
            if (StatusCode == "0") {
              toast(ResponseMessage);
            }
            else {
              toast(ResponseMessage);
            }
          }
          catch (error) {
            if (error?.response?.data?.message) {
              toast(error.response.data.message);
            }
          }
        },
        error: function (jqXHR, ajaxOptions, thrownError) {
          toast(getHttpError(jqXHR));
        },
      });
    } catch (error) {
      toast(getHttpError(error));
    }
  };

  const getHttpError = (error) => {
    let err = "Unhandled Exception";
    if (!error.response) {
      err = 'Service Unavailable';
    } else if (error.response.status === 404) {
      err = 'Requested page not found';
    } else if (error.response.status === 500) {
      err = 'Internal Server Error';
    } else if (error.message === 'timeout') {
      err = 'Time out error';
    } else if (error.message === 'abort') {
      err = 'Ajax request aborted';
    } else {
      err = 'Unhandled Error';
    }
    return err;
  };

  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
    }
  };

  const getServiceCharge = async (e, serviceData) => {
    deleteError(e);
    let price = e.target.value;
    let requestData = {
      payment_mode: serviceData.paymentMode,
      transfer_amount: price,
      customerId: data[0].customerId
    };
    try {
      let response = await axios.post('/prabhuRemittance/getServiceCharge', requestData);
      const { status, message, data } = response.data;
      if (status) {
        setCommissionData(data);
      }
      else {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const changeData = async (e) => {
    const { name, value } = e.target;
    deleteError(e);
    try {
      let changeReceiverData = { ...receiverData, [name]: value };
      console.log(changeReceiverData);
      setReceiverData(changeReceiverData);
      if (name == "payment_mode") {
        setPaymentMode(value);
        if (value == "Account Deposit") {
          getBankName(changeReceiverData);
        }
      }
      if (name == "country") {
        getStateData(e);
      }
      if (name == "state") {
        getDistrictData(e, "Nepal");
      }
      if (name == "district") {
        getLocalLevelData(e);
      }
      if (name == "bank") {
        getBankBranch(e);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getBankName = async (receiverData) => {
    try {
      console.log(receiverData);
      const response = await axios.post('/prabhuRemittance/getBankName', receiverData);
      const { status } = response.data;
      if (status) {
        setBankName(response.data.banks);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getBankBranch = async (e) => {
    try {
      const response = await axios.post('/prabhuRemittance/getBankBranch', { bankName: e.target.value });
      const { status } = response.data;
      if (status) {
        setBankBranchName(response.data.banks);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getIdType = async (e) => {
    deleteError(e);
    setIdType(e.target.value);
  };

  const handleFileChange = (e) => {
    deleteError(e);
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setBase64({ ...base64, [e.target.name]: base64String });
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadDocument = async (e) => {
    e.preventDefault();
    try {
      let sendData = {
        customerId: data[0].customerId,
        id_type: data[0].id_type,
        id_proof_front: base64.id_proof_front,
        id_proof_back: base64.id_proof_back,
        photo: base64.photo
      };
      const response = await axios.post('/prabhuRemittance/uploadDocument', sendData);
      const { status, message } = response.data;
      toast(message);
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  let relationshipData = [{ "value": "18", "label": "NIECE", "type": null }, { "value": "9", "label": "FATHER", "type": null }, { "value": "23", "label": "SON", "type": null }, { "value": "21", "label": "SISTER", "type": null }, { "value": "10", "label": "FATHER IN LAW", "type": null }, { "value": "17", "label": "MOTHER IN LAW", "type": null }, { "value": "5", "label": "DAUGHTER", "type": null }, { "value": "14", "label": "HUSBAND", "type": null }, { "value": "30", "label": "NEPHEW", "type": null }, { "value": "22", "label": "SISTER IN LAW", "type": null }, { "value": "1", "label": "AUNT", "type": null }, { "value": "3", "label": "BROTHER IN LAW", "type": null }, { "value": "4", "label": "COUSIN", "type": null }, { "value": "2", "label": "BROTHER", "type": null }, { "value": "15", "label": "MOTHER", "type": null }, { "value": "13", "label": "GRANDFATHER", "type": null }, { "value": "11", "label": "FRIEND", "type": null }, { "value": "19", "label": "SELF", "type": null }, { "value": "28", "label": "UNCLE", "type": null }, { "value": "29", "label": "WIFE", "type": null }, { "value": "16", "label": "GRANDMOTHER", "type": null }, { "value": "36", "label": "RELATIVE", "type": null }, { "value": "37", "label": "GIRLFRIEND", "type": null }];
  //let remittanceReason = [{ "value": "5", "label": "EDUCATIONAL EXPENSES", "type": null }, { "value": "21", "label": "PILGRIMAGE/RELIGIOUS-RELATED", "type": null }, { "value": "14", "label": "INVESTMENT IN SHARES", "type": null }, { "value": "6", "label": "FAMILY MAINTENANCE/SAVING", "type": null }, { "value": "10", "label": "INSURANCE PREMIUM", "type": null }, { "value": "12", "label": "INVESTMENT IN REAL ESTATE", "type": null }, { "value": "13", "label": "INVESTMENT IN SECURITIES", "type": null }, { "value": "16", "label": "MEDICAL EXPENSES", "type": null }, { "value": "22", "label": "REPAYMENT OF LOANS", "type": null }, { "value": "4", "label": "DONATION", "type": null }, { "value": "33", "label": "CELEBRATIONS AND FESTIVALS", "type": null }, { "value": "34", "label": "RETIREMENT SAVINGS", "type": null }, { "value": "37", "label": "UTILITY PAYMENTS", "type": null }, { "value": "11", "label": "INTEREST ON LOANS", "type": null }];
  //let sourceOfFund = [{ "value": "2", "label": "Business", "type": null }, { "value": "4", "label": "Donation/Gift", "type": null }, { "value": "25", "label": "Lottery", "type": null }, { "value": "18", "label": "Salary/Saving", "type": null }, { "value": "29", "label": "Allowance/Pocket Money", "type": null }, { "value": "27", "label": "Bonus Income", "type": null }, { "value": "3", "label": "Claims/Compensation", "type": null }, { "value": "28", "label": "Consulting Income", "type": null }, { "value": "5", "label": "Financial Support from Children", "type": null }, { "value": "6", "label": "Financial Support from Parents", "type": null }, { "value": "7", "label": "Financial Support from Spouse", "type": null }, { "value": "9", "label": "Gambling", "type": null }, { "value": "10", "label": "Insurance", "type": null }, { "value": "24", "label": "Interest", "type": null }, { "value": "11", "label": "Interest/Dividend income", "type": null }, { "value": "14", "label": "Loans", "type": null }, { "value": "17", "label": "Retirement funds", "type": null }, { "value": "19", "label": "Sales of Assets", "type": null }, { "value": "20", "label": "Share Investment", "type": null }, { "value": "34", "label": "Social Security Benefits", "type": null }, { "value": "31", "label": "Tuition and Education Income", "type": null }];

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                Search Sender (Indo Nepal Money Transfer)
                <Button className="float-right" variant="primary" onClick={handleShow}>
                  Add
                </Button>
              </h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Search By</label>
                    <select className="form-control" name="search_by" onChange={(e) => setSearchBy(e.target.value)}>
                      <option value="mobile">Mobile Number</option>
                      <option value="id">ID Number</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    {
                      searchBy == "id" ? (
                        <>
                          <label>ID Number</label>
                          <input className="form-control" type="number" name="id_number" required />
                        </>
                      ) : (
                        <>
                          <label>Mobile</label>
                          <input className="form-control" type="number" name="mobile" />
                          <span className="error">{errors && errors?.mobile}</span>
                        </>
                      )
                    }
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {
                data && (
                  <>
                    <h4 className="card-title">
                      Sender/Receiver Data
                      <Button className="float-right" variant="primary" onClick={(e) => setAddReceiverModal(true)}>
                        Add Receiver
                      </Button>
                    </h4>
                    <div className="col-lg-12 transactionDetail">
                      <div>Total Transactions: {data[0]?.transactions?.year}</div>
                    </div>
                    <hr />
                    <ul className="showData">
                      {Object.entries(data[0]).map(([key, value]) => (
                        (!['_id', 'created_at', 'updated_at', '__v'].includes(key) && (key == "transactions" || typeof value != 'object') && value != "" && value != null) && (
                          <li key={key}>
                            <strong>{addSpaceBetweenCases(key)}:</strong>
                            <div>{key == "transactions" ? value.year : value}</div>
                          </li>
                        )
                      ))}
                    </ul>
                    {data[0].sender_ekyc_status == "Unverified" || data[0].sender_onboarding_status == "Pending" ? (
                      <div>
                        {
                          (partnerUniqueRefNo && tokenData) ? (
                            <form onSubmit={captureFinger}>
                              <div className="row justify-content-center">
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-lg-3 col-md-3">
                                      <label>Customer Type</label>
                                      <select className="form-control" name="CustomerType" required>
                                        <option value="">--Select--</option>
                                        <option value="1">Salaried</option>
                                        <option value="2">Self Employed including Professional</option>
                                        <option value="3">Farmer</option>
                                        <option value="4">Housewife</option>
                                      </select>
                                    </div>
                                    <div className="col-lg-3 col-md-3">
                                      <label>Source Income Type</label>
                                      <select className="form-control" name="SourceIncomeType" required>
                                        <option value="">--Select--</option>
                                        <option value="1">Govt</option>
                                        <option value="2">Public sector</option>
                                        <option value="3">Private Sector</option>
                                        <option value="4">Business</option>
                                        <option value="5">Agriculture</option>
                                        <option value="6">Dependent</option>
                                      </select>
                                    </div>
                                    <div className="col-lg-3 col-md-3">
                                      <label>Annual Income</label>
                                      <select className="form-control" name="AnnualIncome" required>
                                        <option value="">--Select--</option>
                                        <option value="1">Rs. 0.00 lacs to Rs. 2.00 Lacs</option>
                                        <option value="2">Rs. 2.00 Lacs to Rs. 5 Lacs</option>
                                        <option value="3">Rs. 5 Lacs to Rs. 10 Lacs</option>
                                        <option value="4">More than Rs. 10 Lacs</option>
                                      </select>
                                    </div>
                                    <div className="col-lg-3 col-md-3">
                                      <button className="search-btn btn btn-primary" type="submit">Capture Finger and Onboard</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          ) : (
                            <>
                              <p>KYC is not verified</p>
                              <button className="btn btn-primary" onClick={verifyKyc}>Verify KYC</button>
                            </>
                          )
                        }
                      </div>
                    ) : data[0].approveStatus == "NoDocument" || data[0].approveStatus == "Rejected" ? (
                      <>
                        <form className="searchForm" onSubmit={uploadDocument}>
                          <div className="row">
                            <div className="col-lg-4 col-md-4">
                              <label>ID Proof(Front)</label>
                              <input className="form-control" type="file" name="id_proof_front" onChange={handleFileChange} requiredField="true" />
                              <span className="error">{errors && errors?.id_proof_front}</span>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <label>ID Proof(Back)</label>
                              <input className="form-control" type="file" name="id_proof_back" onChange={handleFileChange} requiredField="true" />
                              <span className="error">{errors && errors?.id_proof_back}</span>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <label>Photo</label>
                              <input className="form-control" type="file" name="photo" onChange={handleFileChange} requiredField="true" />
                              <span className="error">{errors && errors?.photo}</span>
                            </div>
                            <div className="col-lg-3 col-md-3">
                              <button className="search-btn btn btn-primary" type="submit">Upload Document</button>
                            </div>
                          </div>
                        </form>
                      </>
                    ) : (
                      <>
                        <DataTable
                          value={data[0].receivers}
                          size="small"
                          className="custom-table"
                        >
                          <Column
                            field="index"
                            header="#"
                            sortable
                            body={(rowData, { rowIndex }) => <span data-label="#">{rowIndex + 1}</span>}
                          />
                          <Column
                            field="receiverId"
                            header="Receiver ID"
                            sortable
                            body={(rowData) => <span data-label="Receiver ID">{rowData.receiverId}</span>}
                          />
                          <Column
                            field="Name"
                            header="Name"
                            sortable
                            body={(rowData) => <span data-label="Name">{rowData?.name}</span>}
                          />
                          <Column
                            field="PaymentMode"
                            header="Payment Mode"
                            sortable
                            body={(rowData) => <span data-label="PaymentMode">{rowData?.paymentMode}</span>}
                          />
                          <Column
                            field="BankName"
                            header="Bank Name"
                            sortable
                            body={(rowData) => <span data-label="BankName">{rowData.bankName}</span>}
                          />
                          <Column
                            field="AcNumber"
                            header="Account Number"
                            sortable
                            body={(rowData) => <span data-label="AccountNumber">{rowData.acNumber}</span>}
                          />
                          <Column
                            field="action"
                            header="Action"
                            sortable
                            body={
                              (rowData, { rowIndex }) => (
                                <span data-label="Action">
                                  <button className="btn btn-primary" onClick={() => handleViewData(rowIndex)}>Send</button>
                                </span>
                              )
                            }
                          />
                        </DataTable>
                      </>
                    )}
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Create New Sender</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Full Name</label>
                    <input className="form-control" type="text" name="fullName" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.fullName}</span>
                  </div>
                  {/* <div className="col-lg-4 col-md-4">
                    <label>First Name</label>
                    <input className="form-control" type="text" name="firstName" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.firstName}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Middle Name</label>
                    <input className="form-control" type="text" name="middleName" onChange={deleteError} />
                    <span className="error">{errors && errors?.middleName}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Last Name</label>
                    <input className="form-control" type="text" name="lastName" onChange={deleteError} />
                    <span className="error">{errors && errors?.lastName}</span>
                  </div> */}
                  <div className="col-lg-4 col-md-4">
                    <label>Gender</label>
                    <select className="form-control" name="gender" onChange={deleteError} requiredField="true">
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    <span className="error">{errors && errors?.gender}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Date of birth</label>
                    <input className="form-control" type="date" name="date_of_birth" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.date_of_birth}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Mobile</label>
                    <input className="form-control" type="number" name="mobile" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.mobile}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Temporary Address</label>
                    <input className="form-control" type="text" name="tempAddress" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.tempAddress}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Temporary Country</label>
                    <select className="form-control" name="tempCountry" onChange={getStateData} requiredField="true">
                      <option value="">Select Country</option>
                      <option value="India">India</option>
                    </select>
                    <span className="error">{errors && errors?.tempCountry}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Temporary State</label>
                    <select className="form-control" name="tempState" onChange={(e) => getDistrictData(e, "India")} requiredField="true">
                      <option value="">--State--</option>
                      {states && states["India"] && states["India"].map((state, index) => (
                        <option value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.tempState}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Temporary District</label>
                    <select className="form-control" name="tempDistrict" onChange={deleteError} requiredField="true">
                      <option value="">Select District</option>
                      {districts && districts["India"] && districts["India"].map((district, index) => (
                        <option value={district}>
                          {district}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.tempDistrict}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Temporary City</label>
                    <input className="form-control" type="text" name="tempCity" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.tempCity}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Temporary Pin Code</label>
                    <input className="form-control" type="text" name="tempPinCode" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.tempPinCode}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Permanent Address</label>
                    <input className="form-control" type="text" name="address" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.address}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Permanent Country</label>
                    <select className="form-control" name="country" onChange={getStateData} requiredField="true">
                      <option value="">Select Country</option>
                      <option value="Nepal">Nepal</option>
                    </select>
                    <span className="error">{errors && errors?.country}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Permanent State</label>
                    <select className="form-control" name="state" onChange={(e) => getDistrictData(e, "Nepal")} requiredField="true">
                      <option value="">--State--</option>
                      {states && states["Nepal"] && states["Nepal"].map((state, index) => (
                        <option value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.state}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Permanent District</label>
                    <select className="form-control" name="district" onChange={getLocalLevelData} requiredField="true">
                      <option value="">Select District</option>
                      {districts && districts["Nepal"] && districts["Nepal"].map((district, index) => (
                        <option value={district}>
                          {district}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.district}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Permanent Local Level</label>
                    {/* <input className="form-control" type="text" name="localLevel" onChange={deleteError} requiredField="true" /> */}
                    <select className="form-control" name="localLevel" onChange={deleteError} requiredField="true">
                      <option value="">Select Local Level</option>
                      {localLevel && localLevel.map((level, index) => (
                        <option value={level}>
                          {level}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.localLevel}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Permanent Ward Number</label>
                    <input className="form-control" type="text" name="wardNumber" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.wardNumber}</span>
                  </div>
                  {/* <div className="col-lg-4 col-md-4">
                        <label>Father Name</label>
                        <input className="form-control" type="text" name="fatherName" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.fatherName}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Email</label>
                        <input className="form-control" type="text" name="email" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.email}</span>
                      </div> */}
                  {/* <div className="col-lg-4 col-md-4">
                    <label>Employer</label>
                    <select className="form-control" name="employer" onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="Self">Self</option>
                      <option value="Salaried">Salaried</option>
                    </select>
                    <span className="error">{errors && errors?.employer}</span>
                  </div> */}
                  <div className="col-lg-4 col-md-4">
                    <label>Id Type</label>
                    <select className="form-control" name="id_type" onChange={getIdType} requiredField="true">
                      <option value="">Select Id Type</option>
                      <option value="Aadhaar Card">Aadhaar Card</option>
                      <option value="Nepalese Citizenship">Nepalese Citizenship</option>
                      <option value="Nepalese Passport">Nepalese Passport</option>
                    </select>
                    <span className="error">{errors && errors?.id_type}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Id Number</label>
                    <input className="form-control" type="number" name="id_number" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.id_number}</span>
                  </div>
                  {
                    idType && idType == "Nepalese Passport" && (
                      <div className="col-lg-4 col-md-4">
                        <label>Citizenship Number</label>
                        <input className="form-control" type="number" name="citizenshipNumber" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.citizenshipNumber}</span>
                      </div>
                    )
                  }
                  {/* <div className="col-lg-4 col-md-4">
                    <label>ID Issued Date</label>
                    <input className="form-control" type="date" name="idIssuedDate" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.idIssuedDate}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>ID Expiry Date</label>
                    <input className="form-control" type="date" name="idExpiryDate" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.idExpiryDate}</span>
                  </div> */}
                  <div className="col-lg-4 col-md-4">
                    <label>ID Issued Place</label>
                    <input className="form-control" type="text" name="id_issue_place" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.id_issue_place}</span>
                  </div>
                  {/* <div className="col-lg-4 col-md-4">
                    <label>Customer Type</label>
                    <select className="form-control" name="customerType" onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="16">Salaried</option>
                      <option value="15">Self Employed</option>
                      <option value="14">Farmer</option>
                      <option value="17">Housewife</option>
                    </select>
                    <span className="error">{errors && errors?.customerType}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Source Income Type</label>
                    <select className="form-control" name="sourceIncomeType" onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="8">Govt</option>
                      <option value="9">Public sector</option>
                      <option value="10">Private Sector</option>
                      <option value="11">Business</option>
                      <option value="13">Agriculture</option>
                      <option value="12">Dependent</option>
                    </select>
                    <span className="error">{errors && errors?.sourceIncomeType}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Annual Income</label>
                    <select className="form-control" name="annualIncome" onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="6">Rs. 0.00 lacs to Rs. 2.00 Lacs</option>
                      <option value="7">Rs. 2.00 Lacs to Rs. 5 Lacs</option>
                      <option value="8">Rs. 5 Lacs to Rs. 10 Lacs</option>
                      <option value="9">More than Rs. 10 Lacs</option>
                    </select>
                    <span className="error">{errors && errors?.annualIncome}</span>
                  </div> */}
                  {
                    idType && idType != "Aadhaar Card" && (
                      <>
                        <div className="col-lg-4 col-md-4">
                          <label>ID Proof(Front)</label>
                          <input className="form-control" type="file" name="id_proof_front" onChange={handleFileChange} requiredField="true" />
                          <span className="error">{errors && errors?.id_proof_front}</span>
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <label>ID Proof(Back)</label>
                          <input className="form-control" type="file" name="id_proof_back" onChange={handleFileChange} requiredField="true" />
                          <span className="error">{errors && errors?.id_proof_back}</span>
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <label>Photo</label>
                          <input className="form-control" type="file" name="photo" onChange={handleFileChange} requiredField="true" />
                          <span className="error">{errors && errors?.photo}</span>
                        </div>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
            {
              processId != "" && (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <div><label>OTP</label></div>
                        <input className="form-control" type="number" name="otp" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.otp}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Create Customer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={viewData} onHide={handleClose} centered size='xl' backdrop="static">
        <Form onSubmit={transferAmountSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Receiver Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              (data && data[0].receivers && (data[0].receivers).length > 0) && (
                <>
                  <ul className="showData">
                    {Object.entries(data[0].receivers[viewIndex]).map(([key, value]) => (
                      (value != "" && value != null) && (
                        <li key={key}>
                          <strong>{addSpaceBetweenCases(key)}:</strong>
                          <div>{value}</div>
                        </li>
                      )
                    ))}
                    <li>
                      <strong>Transfer Amount (₹):</strong>
                      <div><input className="form-control" type="number" name="transferAmount" onChange={(e) => getServiceCharge(e, data[0].receivers[viewIndex])} max="50000" required /></div>
                    </li>
                    {/* <li>
                      <strong>Remittance Reason:</strong>
                      <div>
                        <select className="form-control" name="remittanceReason" required>
                          <option value="">--Select--</option>
                          {remittanceReason.map(item => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </li>
                    <li>
                      <strong>Source Of Fund:</strong>
                      <div>
                        <select className="form-control" name="sourceOfFund" required>
                          <option value="">--Select--</option>
                          {sourceOfFund.map(item => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </li> */}
                    {
                      commissionData && (
                        <>
                          <li>
                            <strong>PayOut Amount:</strong>
                            <div>{commissionData.payoutAmount} {commissionData.payoutCurrency}</div>
                          </li>
                          <li>
                            <strong>Exchange Rate:</strong>
                            <div>{commissionData.exchangeRate}</div>
                          </li>
                          <li>
                            <strong>Service Charge:</strong>
                            <div>{commissionData.serviceCharge}</div>
                          </li>
                          <li>
                            <strong>Collection Amount:</strong>
                            <div>{commissionData.collectionAmount} {commissionData.collectionCurrency}</div>
                          </li>
                        </>
                      )
                    }
                    {
                      (processId != "") ? (
                        <li>
                          <strong>OTP:</strong>
                          <div><input className="form-control" type="number" name="otp" required /></div>
                        </li>
                      ) : (
                        <li></li>
                      )
                    }
                  </ul>
                </>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Transfer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={addReceiverModal} onHide={handleClose} centered size={processId == "" ? 'xl' : 'sm'} backdrop="static">
        <Form onSubmit={addReceiverSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Receiver</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Full Name</label>
                    <input className="form-control" type="text" name="fullName" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.fullName}</span>
                  </div>
                  {/* <div className="col-lg-4 col-md-4">
                    <label>First Name</label>
                    <input className="form-control" type="text" name="firstName" value={receiverData?.firstName} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.firstName}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Middle Name</label>
                    <input className="form-control" type="text" name="middleName" value={receiverData?.middleName} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Last Name</label>
                    <input className="form-control" type="text" name="lastName" value={receiverData?.lastName} onChange={changeData} />
                  </div> */}
                  <div className="col-lg-4 col-md-4">
                    <label>Gender</label>
                    <select className="form-control" name="receiver_gender" value={receiverData?.receiver_gender} onChange={changeData} requiredField="true">
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    <span className="error">{errors && errors?.receiver_gender}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Mobile Number</label>
                    <input className="form-control" type="number" name="receiver_mobile" value={receiverData?.receiver_mobile} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.receiver_mobile}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Relationship</label>
                    <select className="form-control" name="relationship" value={receiverData?.relationship} onChange={changeData} requiredField="true">
                      <option value="">--Select--</option>
                      {relationshipData.map(item => (
                        <option key={item.label} value={item.label}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.relationship}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Address</label>
                    <input className="form-control" type="text" name="receiver_address" value={receiverData?.receiver_address} onChange={changeData} requiredField="true" />
                    <span className="error">{errors && errors?.receiver_address}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Country</label>
                    <select className="form-control" name="country" onChange={changeData} requiredField="true">
                      <option value="">Select Country</option>
                      <option value="Nepal">Nepal</option>
                    </select>
                    <span className="error">{errors && errors?.country}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>State</label>
                    <select className="form-control" name="state" onChange={changeData} requiredField="true">
                      <option value="">--State--</option>
                      {states && states["Nepal"] && states["Nepal"].map((state, index) => (
                        <option value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.state}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>District</label>
                    <select className="form-control" name="district" onChange={changeData} requiredField="true">
                      <option value="">Select District</option>
                      {districts && districts["Nepal"] && districts["Nepal"].map((district, index) => (
                        <option value={district}>
                          {district}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.district}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Local Level</label>
                    <select className="form-control" name="localLevel" onChange={changeData} requiredField="true">
                      <option value="">Select Local Level</option>
                      {localLevel && localLevel.map((level, index) => (
                        <option value={level}>
                          {level}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.localLevel}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Payment Mode</label>
                    <select className="form-control" name="payment_mode" value={receiverData?.payment_mode} onChange={changeData} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="Account Deposit">Account Deposit</option>
                      <option value="Cash Payment">Cash Payment</option>
                    </select>
                    <span className="error">{errors && errors?.payment_mode}</span>
                  </div>
                  {
                    (paymentMode && paymentMode == "Account Deposit") && (
                      <>
                        <div className="col-lg-4 col-md-4">
                          <label>Bank Name</label>
                          <select className="form-control" name="bank" value={receiverData?.bank} onChange={changeData} requiredField="true">
                            <option value="">--Select--</option>
                            {
                              bankName && bankName.map((data, index) => (
                                <>
                                  <option value={data}>{data}</option>
                                </>
                              ))
                            }
                          </select>
                          <span className="error">{errors && errors?.bank}</span>
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <label>Bank Branch</label>
                          <select className="form-control" name="bank_branch_id" value={receiverData?.bank_branch_id} onChange={changeData} requiredField="true">
                            <option value="">--Select--</option>
                            {
                              bankBranchName && bankBranchName.map((data, index) => (
                                <>
                                  <option value={data.bankBranchId}>{data.branchName}</option>
                                </>
                              ))
                            }
                          </select>
                          <span className="error">{errors && errors?.bank_branch_id}</span>
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <label>Account Number</label>
                          <input className="form-control" type="text" name="account_number" value={receiverData?.account_number} onChange={changeData} requiredField="true" />
                          <span className="error">{errors && errors?.account_number}</span>
                        </div>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {'Create Receiver'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default IndoNepalMoneyTransfer1;
